var $cf76f2b22038d1dc$exports = {};
$cf76f2b22038d1dc$exports = {
    "collectionLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`
};


export {$cf76f2b22038d1dc$exports as default};
//# sourceMappingURL=bg-BG.module.js.map
